import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BookingContextService } from './booking-context.service';
import { BookingActivationRequiredDialogComponent } from '../components/booking-activation-required-dialog/booking-activation-required-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class BookingActivationGuardService {

  constructor(
    private bookingContextService: BookingContextService,
    private dialog: MatDialog
  ) { }

  verifyBookingIsActive(): Observable<boolean> {
    return this.bookingContextService.getBookingMerchantStatus().pipe(
      map(response => {
        const isActive = !!(response && response.isSuccess && response.value && response.value.isActive);
        return isActive;
      }),
      catchError(() => {
        // En caso de error, permitir acceso para no bloquear la aplicación
        console.error('Error verificando estado de activación de booking');
        return of(true);
      })
    );
  }

  verifyAndRedirectIfInactive(): Observable<boolean> {
    return this.bookingContextService.getBookingMerchantStatus().pipe(
      map(response => {
        const isActive = !!(response && response.isSuccess && response.value && response.value.isActive);
        
        if (!isActive) {
          this.showActivationDialog();
        }
        
        return isActive;
      }),
      catchError(() => {
        // En caso de error, permitir acceso para no bloquear la aplicación
        console.error('Error verificando estado de activación de booking');
        return of(true);
      })
    );
  }

  private showActivationDialog(): void {
    this.dialog.open(BookingActivationRequiredDialogComponent, {
      width: '480px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'ard-dialog-panel'
    });
  }
}
